module.exports = __webpack_public_path__ + "static/media/YFI.1ac4b34e.svg";